import { SET_CURRENT_TODO } from "../types";


export const setCurrTodo = (todoObj) => ({
  type:SET_CURRENT_TODO,
  payload: todoObj
})